import { Modal } from 'primsell-shared-layer/components'

import { SadFaceIcon } from 'primsell-shared-layer/assets/icons'

import * as S from './reward-expired-modal.styles'

const RewardExpiredModal = () => {
  return (
    <Modal>
      <Modal.Content>
        <SadFaceIcon />
        <S.TextTypography>
          Unfortunately your reward is expired, please try to redeem your reward before expiration date next time.
        </S.TextTypography>
      </Modal.Content>
    </Modal>
  )
}

export { RewardExpiredModal }
